import { Controller } from "@hotwired/stimulus"
import { MaskInput } from "maska"

export default class extends Controller {
    connect() {
        this.mask = new MaskInput(this.element.querySelector('input.grow'), {
            number: {
                locale: 'us',
                fraction: 2,
                unsigned: true
            },
            postProcess: (val) => val ? `$${val}` : ''
        })
    }

    disconnect() {
        if (this.mask) {
            this.mask.destroy()
        }
    }
}